<template>
    <div ref="organize" id="organize">
        <div class="title clearfix">
            <div class="f-l" @click='root' id="root"><img :src="homeUrl">组织</div>
            <div class="f-r" v-show="!$store.state.isLook&&$store.state.functionList.includes('groupEdit')">
                <img ref="add" title="新建" :src="add" @mouseover="imgHover('add')" @mouseout="disHover('add')" @click="popup('add')" v-show='treeObj.level != 9&&treeObj.type!=3'>
                <img :src="add3" v-show='treeObj.level == 9 ||treeObj.type==3' title="新建">
                <img ref="edit" title="编辑" :src="edit" @mouseover="imgHover('edit')" @mouseout="disHover('edit')"  @click="popup('edit')" v-show='!editNot'>
                <img :src="edit3" v-show='editNot' title="编辑">
                <img ref="del" title="删除" style="width: 18px;" :src="del" @mouseover="imgHover('del')" @mouseout="disHover('del')"  @click="popup('del')" v-show='!delNot&&treeObj.type!=3'>
                <img style="width: 18px;" title="删除" :src="del3" v-show='delNot||treeObj.type==3'>
            </div>
            <div class="f-r not-allowed" v-show="$store.state.isLook || !$store.state.functionList.includes('groupEdit')">
                <img :src="add3" title="新建">
                <img :src="edit3" title="编辑">
                <img style="width: 18px;" title="删除" :src="del3">
            </div>
        </div>
        <!-- 组织树  -->
        <div class="tree" :style="recoveryName !='' ? null : {'height': '98%'}">
            <el-tree ref="tree" :indent='0' :default-expanded-keys="$store.state.expandedArr" :draggable="!$store.state.isLook" @node-drag-start='dragStart' :expand-on-click-node="false" :allow-drop='dropInner' @node-drop='drop' :data="$store.state.treeData" :check-on-click-node="false" node-key="key" @node-click="getId" :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node, data }" :ref="setRef(data)">
                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                    <span :class="generateClassName(data.id)" >{{ node.label }}</span> <span v-if='data.roleName'>({{data.roleName}})</span>
                </span>
            </el-tree>
        </div>
        <div class="recycle-bin" @click='recovery' v-show="recoveryName !=''">
            <img :src="del">
            {{recoveryName}}
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 新建组织 -->
            <div class="popup-add" v-show='addShow'>
                <div class="popup-title">
                    新建组织<i class="el-icon-circle-close close" @click="close('add')" id="closeAddOr"></i>
                </div>
                <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix">
                    <div class="popup-lab p-r" @click='setFasle'>
                        <el-form-item prop="orName" label="组名称：" autocomplete="off" class="no-title">
                            <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                            <el-input v-model="ruleForm.orName" maxlength="32" placeholder="请输入组名称"></el-input>
                        </el-form-item>
                        <el-form-item prop="type" label="组类型：" autocomplete="off" class="no-title">
                            <i><img :src="notes" title="普通组下的用户只能访问本组下的数据，继承组下的用户访问权限同上一级组，企业组类型不可编辑" class="notes"></i>
                            <el-select v-model="ruleForm.type" id="addOrType" placeholder="请选择" class="type-select" @focus="setFasle">
                                <el-option label="普通组" :value=1>  </el-option>
                                <el-option label="继承组" :value=2>  </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="userNum" label="限定用户数：" autocomplete="off" class="no-title">
                            <i><img :src="notes" title="表示该组可容纳的最大用户数，超过此数量限制则不能新建或移动用户，0表示不限制，最大9999" class="notes"></i>
                            <el-input v-model="ruleForm.userNum" placeholder="请输入限定用户数" @input="ruleForm.userNum=ruleForm.userNum.replace(/[^0-9]/g, '')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="popup-lab">
                        所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes" style="top: 3px;"></i>
                        <div class="or-Superior" @click='showSelect' id="addOrSelect1" :style="addOrMax ? {'border': '1px solid #F56C6C'}: null">
                            {{orSuperior.name}}
                            <i><img :src="down" @click="showSelect" id="addOrSelect2"></i>
                            <div class="select-box tree" ref="selectbox" v-show='selectShow' style="min-height: 200px;">
                                <div class="dashed">
                                    <el-tree :data="orSuperiorData" :indent='0' node-key="key" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                            <span :class="generateClassName(data.id)">{{ node.label }} <span v-if='data.roleName'>({{data.roleName}})</span></span>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                            <span v-show="addOrMax" class="red err">操作失败，此操作将导致组织层级超过10级</span>
                        </div>
                    </div>
                </el-form>
                <div class="btn-box">
                   <el-button type="primary" @click='create' id="yesAddOr">确定</el-button>
                   <el-button @click="close('add')" id="noAddOr">取消</el-button>
                </div>
            </div>
            <!-- 编辑组织 -->
            <div class="popup-edit" v-show='editShow'>
                <div class="popup-title">
                    编辑组织<i class="el-icon-circle-close close" @click="close('edit')" id="closeEditOr"></i>
                </div>
                <el-form :model='ruleForm' :rules="rules" ref="editForm" class="clearfix">
                    <div class="popup-lab p-r" @click='setFasle'>
                        <el-form-item prop="orName" label="组名称：" autocomplete="off" class="no-title" >
                            <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                            <el-input :disabled="treeObj.type==3" v-model="ruleForm.orName" maxlength="32" placeholder="请输入组名称"></el-input>
                        </el-form-item>
                        <el-form-item prop="type" label="组类型：" autocomplete="off" class="no-title">
                            <i><img :src="notes" title="普通组下的用户只能访问本组下的数据，继承组下的用户访问权限同上一级组，企业组类型不可编辑" class="notes"></i>
                            <el-select v-model="ruleForm.type" id="editOrType" placeholder="请选择" class="type-select" @focus="setFasle" :disabled="treeObj.type==3">
                                <el-option label="普通组" :value=1>  </el-option>
                                <el-option label="继承组" :value=2>  </el-option>
                                <el-option label="企业" :value=3 v-show='treeObj.type==3'>  </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="userNum" label="限定用户数：" autocomplete="off" class="no-title">
                            <i><img :src="notes" title="表示该组可容纳的最大用户数，超过此数量限制则不能新建或移动用户，0表示不限制，最大9999" class="notes"></i>
                            <el-input v-model="ruleForm.userNum" placeholder="请输入限定用户数" @input="ruleForm.userNum=ruleForm.userNum.replace(/[^0-9]/g, '')"></el-input>
                        </el-form-item>
                    </div>
                    <div class="popup-lab p-r" v-show="!isRoot&&treeObj.type!=3">
                        所属组织：<i><img :src="notes" title="" class="notes"></i>
                        <div class="or-Superior" @click='showSelect' id="editOrSelect1">
                            {{orSuperior.name}}
                            <i><img :src="down" @click="showSelect" id="editOrSelect2"></i>
                            <div class="select-box tree" ref="selectBox" v-show='selectShow' style="min-height: 200px;">
                                <el-tree :data="orSuperiorData" :indent='0' node-key="key" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps" ref="editTree">
                                    <span class="custom-tree-node" slot-scope="{ node, data }" :ref="generateClassName(data.id)" :id="generateClassName(data.id)">
                                        <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                        <span>{{ node.label}}<span v-if='data.roleName'>({{data.roleName}})</span></span>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                        <span v-show="editMaxTips" class="red err">操作失败，此操作将导致组织层级超过10级</span>
                    </div>
                    <div class="popup-lab p-r" v-show="isRoot||treeObj.type==3">
                        <div class="or-user-num m-b-36">
                            <p>所属组织：<i><img :src="notes" title="根组不能更改上级组" class="notes" style="top: 3px;"></i></p>
                            <el-select id="editOr2" class="type-select" :disabled="true" v-model="orSuperior">
                                <el-option :value="orSuperior.name">根组不能更改上级组</el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form>
                <div class="btn-box">
                    <el-button type="primary" @click='clickEdit' id="yesEditOr">确定</el-button>
                    <el-button @click="close('edit')" id="noEditOr">取消</el-button>
                 </div>
            </div>
            <!-- 删除组织 -->
            <div class="popup-del h-284" v-show='delShow'>
                <div class="popup-title m-b-22">
                    删除组织<i class="el-icon-circle-close close" @click="close('del')" id="closeDelOr"></i>
                </div>
                <div class="popup-lab">
                    <p>组织删除后不可恢复，是否继续？</p>
                    <p class="popup-btn-box"><el-button type="primary" @click='yes' id="yesDelOr">确定</el-button></el-button> <el-button @click="close('del')" id="noDelOr">取消</el-button></p>
                </div>
            </div>
            <!-- 超出层级 -->
            <div class="popup-del" v-show='maxShow'>
                <div class="popup-title center">
                    <p>操作失败，此操作将导致组织层级超过10级</p>
                </div>
                <p class="btn-box"><el-button type="primary" @click="close('max')" id="closeMax">确定</el-button></p>
            </div>
            <!-- 获取权限验证 -->
            <div class="popup-del" v-if='functionShow' id="privilege" style="width: 436px;">
                <div class="popup-title m-b-22">
                    获取验证码授权<i class="el-icon-circle-close close" @click="close('functionShow')" id="functionShow"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getPrivilegeCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click="Privilege" id="privilege2">确定</el-button>
                        <el-button @click="close('functionShow')" id="privilege3">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        var valiUserNum = (rule, value, callback) =>{
            if(value>9999){
                callback(new Error('用户数超出范围：0~9999'));
            }else{
                callback()
            }
        }
        return {
            homeUrl:null,
            add:require('@/assets/image/organize/add.png'),
            del:require('@/assets/image/organize/delete.png'),
            add2:require('@/assets/image/organize/add2.png'),
            del2:require('@/assets/image/organize/delete2.png'),
            edit:require('@/assets/image/organize/edit.png'),
            edit2:require('@/assets/image/organize/edit2.png'),
            add3:require('@/assets/image/organize/add3.png'),
            del3:require('@/assets/image/organize/delete3.png'),
            edit3:require('@/assets/image/organize/edit3.png'),
            add4:require('@/assets/image/organize/add4.png'),
            del4:require('@/assets/image/organize/delete4.png'),
            edit4:require('@/assets/image/organize/edit4.png'),
            area:require('@/assets/image/company/qyzu.png'),
            branch:require('@/assets/image/company/ptzu.png'),
            location:require('@/assets/image/company/jczu.png'),
            notes:require('@/assets/image/organize/notes.png'),
            down:require('@/assets/image/organize/down.png'),
            addShow:false,
            editShow:false,
            delShow:false,
            selectShow:false,
            maxShow:false,
            editNot:true,
            editMaxTips:false,
            delNot:true,
            // 完整数据
            data: [{}],
            // 用于生成组织树
            treeData:[],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            //当前树节点id
            orId:1,
            // 当前树节点对象
            treeObj:{
                id:1,
                level:1,
            },
            orSuperiorData:[],
            type:1,  //组类型
            options: [
                {value: 1,name: '普通组'},
                {value: 2,name: '继承组'},
                {value: 3,name: '企业'},
            ],
            orSuperior:{},      //上级组对象
            userNum:"",         //组织限制数
            orName:"",          //组织名
            obj:null,           //编辑组织时需要隐藏组织元素
            level:1,            //拖拽节点层级
            isRoot:true,        //修改组织为根节点
            nameTrue:true,      //组名格式是否正确
            numTrue:true,       //限制数是否在允许范围
            maxTrue:true,       //最大层级
            nodeObj:{},         //删除节点node对象
            topTreeObjCode:[],
            functionShow:false,
            VerifyArr:[],
            second:60,
            getCodeShow:true,
            countdownShow:false,
            addOrMax:false,
            phone:'',
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                orName:[{ message: '请输入组名称', required: true, trigger: 'blur'}],
                userNum:[{validator: valiUserNum, required: true, trigger: 'blur'}],
                type:[{ message: '请输入验证码', required: true, trigger: 'blur'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur'}],
            },
            // expandedArr:[],
            ruleForm:{
                orName:'',
                type:1,
                userNum:0,
            },
            setBg:true,
            key:''
        }
    },
    props:{
        recoveryName:{
            type: String,
            required:true
        }
    },
    created() {
        this.homeUrl = require("@/assets/image/organize/xinweiwo"+ this.cssType +".png")
        this.getTree()
        // this.treeData = this.$store.state.treeData
        // this.treeObj = this.treeData[0]
        this.phone = this.hidePhone(this.$store.state.userData.mobile)
    },
    updated() {
        if(this.setBg){
            let key = this.treeObj.roleId+'_'+this.treeObj.id+this.treeObj.type
            let obj = this.$refs[key]
            if(obj){
                this.key = key
                obj.parentNode.parentNode.classList.add('is-current')
                this.setBg=false
                // console.log(key)
            }
        }
    },
    methods: {
        // 用户提权
        getPrivilegeCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'success'
                    });
                }
            })
        },
        // 获取组织树
        getTree(){
            let url='';
            if(this.$store.state.treeData.length == 0||this.$route.path=='/Devops'){
                if(this.$route.path == '/company'){
                    url = '/Group/getGroupTree'
                }else{
                    url = '/Group/getOrganizationTree'
                }
                this.get(url).then((res)=>{
                    if(res.success){
                        this.$store.state.treeData=res.result;
                        this.treeData = this.$store.state.treeData
                        this.treeObj = this.treeData[0]
                        this.$emit('setOrId',this.treeObj,this.treeObj.functionSet)
                    }
                }).then(()=>{
                    this.expanded(this.$store.state.treeData,1)
                })
            }else{
                this.treeData = this.$store.state.treeData
                this.treeObj = this.treeData[0]
                this.expanded(this.$store.state.treeData,1)
            }
            this.orSuperiorData.push(this.treeObj)
            this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
        },
        // 图标hover
        imgHover(id){
            if(this.cssType==0){
              if(id=="add"){
                  this.$refs.add.src=this.add2
              }else if(id=="edit"){
                  this.$refs.edit.src=this.edit2
              }else{
                  this.$refs.del.src=this.del2
              }
            }else if(this.cssType==1){
              if(id=="add"){
                  this.$refs.add.src=this.add4
              }else if(id=="edit"){
                  this.$refs.edit.src=this.edit4
              }else{
                  this.$refs.del.src=this.del4
              }
            }
        },
        disHover(id){
            if(id=="add"){
                this.$refs.add.src=this.add
            }else if(id=="edit"){
                this.$refs.edit.src=this.edit
            }else{
                this.$refs.del.src=this.del
            }
        },
        setRef(obj){
            if(obj){
                obj.key = obj.roleId+'_'+obj.id+obj.type
                return obj.roleId+'_'+obj.id+obj.type
            }
        },
        // 弹窗
        popup(name){
            this.ruleForm=this.$options.data().ruleForm
            if(this.VerifyArr.includes(1)){
                this.functionShow = true
                this.$store.state.mask = true
                return
            }
            this.$store.state.mask=true;
            this.selectShow=false
            this.reSet()

            if(name == 'add'){
                this.addShow=true;
                this.orSuperior = this.treeObj
                this.userNum=0
            }else if(name == 'edit'){
                // console.log(this.treeObj)
                if(this.treeObj.id==this.treeData[0].id){
                    this.isRoot=true
                }else{
                    this.isRoot=false
                    this.get('/Group/get',{id:this.treeObj.parentId}).then((res)=>{
                        this.orSuperior=res.result
                    })
                }
                // console.log('show',this.treeObj)
                this.ruleForm.orName=this.treeObj.name;
                this.ruleForm.type=this.treeObj.type;
                this.ruleForm.userNum=this.treeObj.userLimit;
                this.editShow=true
            }else{
                this.delShow=true
            }

        },
        // 关闭弹窗
        close(name){
            if(name=='add'){
                this.addShow=false
            }else if(name=='edit'){
                this.editShow=false
                if(this.obj){
                    this.obj.style.display='block'
                }
            }else{
                this.delShow=false
                this.maxShow=false
                this.functionShow =false
                this.$store.state.mask=false
                this.verifyForm.verifyCode=''
            }
            this.$store.state.mask = false
        },
        // 初始化数据{
        reSet(){
            this.type=1;
            this.orName="";
            this.userNum="";
        },
        // 获取用户点击节点
        getId(data,node){
            if(this.key!=''){
                let obj = this.$refs[this.key]
                if(obj){
                    obj.parentNode.parentNode.classList.remove('is-current')
                    this.setBg=false
                    this.key=''
                }
            }
            this.orId=data.id;
            this.treeObj=node.data;
            this.orSuperior = this.treeObj
            this.nodeObj=node;
            if(node.level==1){
                this.editNot=true
                this.delNot=true
            }else{
                this.editNot=false;
                this.delNot=false;
            }
            let func='';
            for(let obj of this.$store.state.treeData){
                if(data.rootId == obj.id&&data.roleId == obj.roleId){  //查找角色id和根组id都相同的权限
                    func = obj.functionSet.split(',')
                    this.orSuperiorData=[]  //初始化树
                    this.orSuperiorData.push(obj)
                }
            }
            this.$emit('setOrId',data,func)
        },
        // 创建组织
        create(){
            this.$refs.addForm.validate((valid) => {
                if(this.orSuperior.level>=9){
                    this.addOrMax=true
                    return
                }else{
                    this.addOrMax=false
                }
                if (valid) {
                    let parm={
                        parentId:this.orSuperior.id,
                        type:this.ruleForm.type,
                        name:this.ruleForm.orName,
                        userLimit:this.ruleForm.userNum
                    }
                    this.post('/Group/create',parm).then((res)=>{
                        if(res.success){
                            parm.children=[];
                            let id = res.result;
                            let obj = {}
                            this.get('/Group/get',{id:id}).then((res)=>{
                                if(res.success){
                                    obj =res.result
                                    for(let tree of this.$store.state.treeData){
                                        let key = tree.roleId+'_'+this.orSuperior.id+this.orSuperior.type
                                        let parent = this.$refs.tree.getNode(key)       //获取上级组节点
                                        if(parent){
                                            if(parent.type!=3){
                                                obj=this.clone(obj)
                                                obj.rootId = tree.rootId
                                                obj.roleId = tree.roleId
                                                obj.key = tree.roleId+'_'+obj.id+obj.type
                                                obj.level = parent.data.level+1
                                                parent.data.children=parent.data.children?parent.data.children:[]
                                                parent.data.children.push(obj)
                                            }
                                            // console.log(obj)
                                        }
                                    }
                                }
                            })
                            this.$message({
                                message: '新建成功',
                                type: 'success'
                            });
                            this.$store.state.mask=false
                            this.addShow=false
                            // this.$store.state.treeData=this.treeData
                            this.ruleForm = this.$options.data().ruleForm
                            this.$forceUpdate()
                        }else{
                            this.$message({
                                message: `新建失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
            // this.regName('add');
            // this.regNum('add');
            // if(this.orSuperior.level == 10){
            //     this.$refs.addMaxTips.style.display='block';
            //     return
            // }
            // if(this.nameTrue&&this.numTrue){

            // }
        },
        // 编辑组织
        clickEdit(){
            this.$refs.editForm.validate((valid) => {
                if(this.orSuperior.level>=9){
                    this.addOrMax=true
                    return
                }else{
                    this.addOrMax=false
                }
                if (valid) {
                    let parm={};
                    let url = '/Group/update'
                    if(this.treeObj.type == 3){
                        parm={
                            code:this.treeObj.code,
                            name:this.ruleForm.orName,
                            userLimit:this.ruleForm.userNum?this.ruleForm.userNum:0,
                            parentId:this.orSuperior.id
                        }
                        url = "/Group/updateCompanyTree"
                    }else if(this.orId == this.treeData[0].id){
                        parm={
                            parentId:this.treeData[0].parentId,
                            type:this.treeData[0].type,
                            userLimit:this.treeData[0].userLimit,
                            id:this.treeData[0].id
                        }
                    }else{
                        parm={
                            parentId:this.orSuperior.id,
                            type:this.ruleForm.type,
                            userLimit:this.ruleForm.userNum,
                            id:this.orId
                        }
                    }
                    parm.name=this.ruleForm.orName;
                    parm.code=this.treeObj.code;
                    // console.log(parm,url)
                    this.post(url,parm).then((res)=>{
                        if(res.success){
                            // this.getTree()
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });

                            for(let tree of this.$store.state.treeData){
                                let key = tree.roleId+'_'+this.treeObj.id+this.treeObj.type
                                let obj = this.$refs.tree.getNode(key)
                                if(obj){
                                    obj.data.name = this.ruleForm.orName
                                    obj.data.type = this.ruleForm.type
                                    obj.data.userLimit = this.ruleForm.userNum
                                    obj.data.parentId = this.orSuperior.id
                                }
                            }

                            this.$store.state.mask=false
                            this.editShow=false
                            // this.$store.state.treeData=this.treeData
                            this.$forceUpdate()
                            // this.$emit('setTree')
                        }else{
                            this.$message({
                                message: `修改失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                        if(this.obj){
                            this.obj.style.display='block'
                        }
                    })
                }
            })
        },
        // 获取tree指定节点
        findPathByLeafId(leafId, nodes) {
            for(var i = 0; i < nodes.length; i++) {
                if(leafId == nodes[i].id){
                    nodes[i].children.push(this.orSuperior.children)
                    // console.log(this.treeData)
                    return true;
                }
                if(nodes[i].children){
                   this.findPathByLeafId(leafId, nodes[i].children);
                }
            }
        },
        // 获取用户点击的上级组节点
        selectId(data){
            if(data.id==this.orId){
                return
            }
            this.orSuperior=data
            this.selectShow=false
            // console.log(this.selectShow)
            // 是否展开编辑页面
            if(this.editShow){
                this.getLevel(1,this.treeObj.children);
                // console.log(this.level)
                // 检测用户选择上级组是否发生超出层级问题
                if(this.orSuperior.level==undefined && this.level + 1 >= 10){
                    this.editMaxTips=true;
                    this.maxTrue=false;
                }else if(this.level+this.orSuperior.level > 9){
                    this.editMaxTips=true;
                    this.maxTrue=false;
                }else{
                    this.editMaxTips=false;
                    this.isTrue=true;
                }
            }
        },
        // 展开上级组
        showSelect(){
            let box = this.$refs.selectbox;
            this.selectShow=!this.selectShow;
            // window.clearInterval(this.time)
            // if(this.isone){
            //     this.s=60
            //     this.time = setInterval(() => {
            //         box.style.height=this.s + 'px'
            //         this.s += 15
            //     }, 8)
            // }

            let id = "item-" + this.orId
            // console.log(this.$refs[id])
            if(this.editShow&&this.$refs[id]){
                this.$refs[id].parentNode.parentNode.style.display="none";
                this.obj = this.$refs[id].parentNode.parentNode
                // console.log(this.obj,this.obj.style.display)
                this.$forceUpdate()
            }
        },
        // 回收
        recovery(){
            this.$emit('recovery')
        },
        // 动态渲染树节点时设置id
        generateClassName (index) {
          return `item-${index}`
        },
        //组织树根节点
        root(){
            // this.orId=1;
            // this.treeObj={};
            // this.treeObj.id=this.data.id;
            // this.treeObj.name=this.data.name;
            // document.querySelector("div[role='group']").style.display='none';
        },
        // 给组织数据添加级别
        // addLevel(data, level) {
        //     if (!data) {
        //         return;
        //     }
        //     let i =0;
        //     for(i;i<data.length;i++){
        //         data[i].level=level;
        //         data[i].key=data[i].roleId+'_'+data[i].id
        //         if(level<5){
        //             this.expandedArr.push(data[i].key)
        //         }
        //         this.addLevel(data[i].children, level + 1);
        //     }
        //     return data;
        // },
        // 获取拖拽父节点下存在子级层数
        getLevel(level,data){
            // console.log('data:',data)
            this.level=level
            if (data==undefined||data.length==0) {
                return level;
            }
            this.getLevel(level + 1,data[0].children);
        },
        // 开始拖拽
        dragStart(data){
            this.getLevel(1,data.data.children)
        },
        // 拖拽节点
        drop(draggingNode, dropNode,type){
            let url,parm
            if(draggingNode.data.type==3){
                url = "/Group/updateCompanyTree"
                parm={
                    code:draggingNode.data.code,
                    name:draggingNode.data.name,
                    userLimit:draggingNode.data.userLimit,
                    parentId:dropNode.data.id
                }
            }else{
                url='/Group/update'
                parm={
                    parentId:dropNode.data.id,
                    type:draggingNode.data.type,
                    name:draggingNode.data.name,
                    userLimit:draggingNode.data.userLimit,
                    id:draggingNode.data.id
                }
            }
            this.post(url,parm).then((res)=>{
                if(res.success){
                    // console.log(draggingNode,dropNode)
                    for(let tree of this.$store.state.treeData){
                        let key = tree.roleId+'_'+draggingNode.data.id+draggingNode.data.type
                        let obj = this.$refs.tree.getNode(key)  //获取需要删除的移动节点
                            // console.log('remove',key)
                        if(obj){
                            if(tree.roleId!=draggingNode.data.roleId){
                                this.remove(obj,obj.data)   //删除节点
                            }

                        }
                    }
                    for(let tree of this.$store.state.treeData){
                        let key = tree.roleId+'_'+dropNode.data.id+dropNode.data.type
                        let obj = this.$refs.tree.getNode(key)  //获取需要添加子节点的节点
                        if(obj){
                            let data = this.clone(draggingNode.data)
                            data.rootId = obj.data.rootId
                            data.roleId = obj.data.roleId
                            data.key = data.roleId+'_'+data.id+data.type
                            // console.log(data.key)
                            // console.log('push',obj,data)
                            if(tree.roleId!=draggingNode.data.roleId){
                                obj.data.children=obj.data.children?obj.data.children:[]
                                obj.data.children.push(data)
                            }
                        }
                    }
                    // this.$emit('setTree')
                }else{
                    this.$message({
                        message: `修改失败：${res.message}`,
                        type: 'warning'
                    });
                    return false
                }
            })
        },
        // 拖拽节点进入其他节点
        dropInner(dropObj,innerObj,type){
            var time=null
            if(this.VerifyArr.includes(1)){
                var that=this
                time=setTimeout(function(){
                    that.functionShow = true
                    that.$store.state.mask = true
                    time=null;
                    clearTimeout(time)
                },500)
                return
            }
            if(innerObj.data.type==3&&dropObj.data.type==3||innerObj.data.type==3){
                return false
            }
            if(innerObj.data.level == 9){
                return type == 'prev';
            }else if(this.level + innerObj.data.level > 10){
                // 拖拽节点和放置节点层级超过限制
                if(!time){
                    var that=this
                    time=setTimeout(function(){
                        that.maxShow=true;
                        that.$store.state.mask=true;
                        time=null;
                        clearTimeout(time)
                    },500)
                }
                return false
            }else if(dropObj.data.rootId!=innerObj.data.rootId||dropObj.data.roleId!=innerObj.data.roleId){
                return false
                // console.log(3)
            }else{
                return type == 'inner';
            }
        },
        // 验证组织名格式
        regName(name){
            let str = this.orName;
            let length = str.replace(/[\u4e00-\u9fa5]/g,"a").length;
            let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            let Tip,input;
            if(name=='add'){
                Tip=this.$refs.addNameTips
                input = this.$refs.addName
            }else{
                Tip=this.$refs.editNameTips
                input = this.$refs.editName
            }
            if(this.orName==""){
                    Tip.style.display='block';
                    Tip.innerText='组名称不能为空';
                    input.style.borderColor='#F56C6C';
                    this.nameTrue=false;
                }else if(!reg.test(this.orName) || length > 32){
                    Tip.style.display='block';
                    Tip.innerText='请输入中文、英文字母、数字和下划线，由1~32个字符构成';
                    input.style.borderColor='#F56C6C';
                    this.nameTrue=false;
                }else{
                    this.nameTrue=true;
                    Tip.style.display='none';
                    input.style.borderColor='#e5e5e5';
                }
        },
        // 验证组织限制数
        inputChange() { //输入框值改变
            this.userNum = this.userNum.replace(/[^\d]/g, '')
        },
        // 验证组织最大用户数
        regNum(name){
            let tip,input;
            if(name=='add'){
                tip=this.$refs.addNumTips;
                input=this.$refs.addNum;
            }else{
                tip=this.$refs.editNumTips;
                input=this.$refs.editNum;
            }
            // console.log(tip,input)
            if(this.userNum < -1 || this.userNum > 9999 ||this.userNum == "" &&this.userNum != 0){
                tip.style.display='block';
                input.$el.style.borderColor='#F56C6C';
                this.numTrue=false;
            }else{
                this.numTrue=true;
                tip.style.display='none';
                input.$el.style.borderColor='#e5e5e5';
            }
            // console.log(input)
        },
        // 确定删除
        yes(){
            // console.log(this.nodeObj,this.treeObj)
            let url = "/Group/remove"
            if(this.treeObj.type==3){
                url = '/Company/remove'
            }
            this.get(url,{id:this.orId}).then((res)=>{
                if(res.success){
                    for(let tree of this.$store.state.treeData){
                        let key = tree.roleId+'_'+this.treeObj.id+this.treeObj.type
                        let obj = this.$refs.tree.getNode(key)
                        if(obj){
                            this.remove(obj,this.treeObj)
                        }
                    }
                    this.$store.state.mask=false
                    this.delShow=false
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.treeObj = this.treeData[0]
                    // this.$emit('setTree')
                }else{
                    this.$message({
                        message: `删除失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 删除节点
        remove(node, data) {
        //   console.log(node,data)
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
          this.editNot=true
        },
        // 上级组为根
        setFasle(){
            this.selectShow=false;
            // console.log('false')
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(1),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
    },
    watch: {
        treeData(){
            this.$store.state.treeData=this.treeData
            this.expanded(this.$store.state.treeData,1)
            // console.log('open')
            // for(let obj of this.treeData){
            //     console.log(obj,'obj')
            // }
        },
    },
}
</script>
<style scoped>
    .p-r{
        position: relative;
    }
    .red{
        color: #F56C6C;
        position: absolute;
        top: 66px;
        left: 0;
    }
    #organize{
        margin:0 16px;
        width: 297px;
        padding: 24px;
        padding-right: 10px;
        box-sizing: border-box;
        background-color: #fff;
        text-align: left;
        position: absolute;
        bottom: 0;
        top: 0;
    }
    #organize .title{
        font-size: 16px;
    }
    .title>div:first-child{
        cursor:pointer
    }
    #organize .title img{
        position: relative;
        top: 2px;
        margin-right: 10px;
        cursor:pointer;
        width: 20px;
    }
    #organize .title img:first-child{
        margin-right: 10px;
    }
    .tree{
        margin-top: 6px;
        overflow: auto;
        height: 88%;
    }
    .recycle-bin{
        position: absolute;
        bottom:35px;
        text-align: center;
        font-size: 16px;
        cursor:pointer;
    }
    .recycle-bin img{
      width: 18px;
    }
    .m-b-36{
        margin-bottom: 36px;
    }
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:255px;
        width: 578px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 48px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    i .notes{
        position: relative;
        top: 5px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .or-name{
        width: 100%;
        border: 1px solid #e5e5e5;
        line-height: 38px;
        font-size: 14px;
        border-radius: 5px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .or-type{
        width: 100%;
        float: left;
        margin-right: 20px;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 18px;
    }
    .type-select{
        width: 100% !important;
        line-height: 34px !important;
    }
    .or-user-num{
        width:100%;
        float: left;
    }
    .or-user-num input{
        width: 100%;
        border:1px solid #e5e5e5;
        line-height: 38px;
        border-radius: 5px;
        margin-right: 8px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .popup-del .popup-title{
        margin-bottom: 12px;
    }
    .btn-box{
        text-align: center;
        margin-top: 30px;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 16px;
    }
    .or-Superior{
        width:100%;
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 10px;
        position: relative;
        box-sizing: border-box;
    }
    .select-box{
        position: absolute;
        left: -1px;
        top: 26px;
        border: 1px solid #e5e5e5;
        max-height: 268px;
        overflow: auto;
        width: 100%;
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .or-Superior>i{
        float: right;
        position: absolute;
        right: 8px;
        top: 6px;
    }
    .or-Superior img{
        width: 22px;
    }
    .center{
        text-align: center;
        border: none;
    }
    .root-obj{
        padding-left: 10px;
        cursor:pointer;
        position: relative;
        line-height: 28px;
        top: 4px;
    }
    .root-obj:hover{
        background-color: #f5f7fa;
    }
    .err{
        top: 30px !important;
        /* left: 8px !important; */
        font-size: 13px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .h-284{
        height: 284px !important;
    }
    .m-b-22{
        margin-bottom: 22px !important;
    }
    .disabledTree{
        color: #C0C4CC !important;
        cursor: not-allowed !important;
    }
</style>
<style>
    #organize .popup .el-form .el-input__inner {
        width: 100% !important;
        height: 34px !important;
        line-height: 34px !important;
    }
    #organize .popup .el-input__icon{
        line-height: 34px !important;
    }
    .tree .is-current>.el-tree-node__content{
        background-color: #dfdfdf !important;
    }
    /* 修改ele-ui 默认样式 */
    .tree .el-tree-node__content .custom-tree-node{
        font-size: 14px !important;
        margin-left: 10px;
        position: relative;
        justify-content:stretch !important;
    }
    .tree .el-tree-node__children .custom-tree-node{
        font-size: 14px !important;
        padding-right: 10px;
    }
    .el-tree-node>.el-tree-node__children {
        overflow: unset !important;
    }
    .tree .el-tree > .el-tree-node:after {
        border-top: none;
    }
    .tree .el-tree-node {
        position: relative;
        padding-left: 16px;
    }
    .tree .el-tree-node__content {
        background: #fff;
    }
    /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
    .tree .el-tree-node__expand-icon.is-leaf{
        display: none;
    }
    .tree .el-tree-node__children {
        padding-left: 16px;
    }
    .tree .el-tree-node :last-child:before {
        height: 18px;
    }
    .tree .el-tree > .el-tree-node:before {
        border-left: none;
    }
    .tree .el-tree > .el-tree-node:after {
        border-top: none;
    }
    .tree .el-tree-node:before {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
    }
    .tree .el-tree-node:after {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
    }
    .tree .el-tree-node:before {
        border-left: 1px dashed #dedede;
        bottom: 0px;
        height: 100%;
        top: -7px;
        width: 1px;
    }
    .tree .el-tree-node:after {
        border-top: 1px dashed #dedede;
        height: 20px;
        top: 12px;
        width: 24px;
    }
    .el-input__inner{
        color: #252525;
    }
    .dashed .el-tree-node:before {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
    }
    .dashed .el-tree-node:after {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
    }
    .dashed .el-tree-node:before {
        border-left: 1px dashed #dedede;
        bottom: 0px;
        height: 100%;
        top: -7px;
        width: 1px;
    }
    .dashed .el-tree-node:after {
        border-top: 1px dashed #dedede;
        height: 20px;
        top: 12px;
        width: 24px;
    }
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/organize.vue